





import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'

export default Vue.extend({
  name: 'DocumentationsFormTitle',
  props: {
    userType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    titulo (): TranslateResult {
      if (!this.userType) {
        return ''
      }
      return this.$t('subasta.documentations.titulo' + this.userType)
    },
    subTitulo (): TranslateResult {
      if (!this.userType) {
        return ''
      }
      return this.$t('subasta.documentations.subTitulo' + this.userType)
    }
  }
})
